// Sprint 10.x Phase B — Types pour /strategy (cockpit fondateur).
// La table `revenue_reports` est créée côté DB par db-agent. En attendant
// que `database.types.ts` soit régénéré, on définit le type inline ici.
// Toute modification de la colonne DB doit être répercutée ici.

export type StrategyAudience = "founder";

export interface RevenueReport {
  id: string;
  generated_at: string;
  generated_by: string | null;
  period_days: number;
  audience: StrategyAudience;
  sectors: string[] | null;
  content: string;
  metrics: Record<string, unknown> | null;
  model: string | null;
  archived_at: string | null;
}

export const STRATEGY_PERIOD_OPTIONS = [
  { value: 7, label: "7 jours" },
  { value: 30, label: "30 jours" },
  { value: 90, label: "90 jours" },
] as const;

export const STRATEGY_SECTOR_OPTIONS = ["ESI", "SSI", "CF", "BE"] as const;
export type StrategySector = (typeof STRATEGY_SECTOR_OPTIONS)[number];

export const STRATEGY_SKILL_ID = "revenue_strategy_report";
export const STRATEGY_SKILL_MODEL = "deepseek-chat";

export const STRATEGY_PERIOD_STORAGE_KEY = "revenue-strategy-period";
export const STRATEGY_SECTORS_STORAGE_KEY = "revenue-strategy-sectors";
